/*
 * This Component is called by <ClassPages />, <ManageClassPatches />, <ManageClassPhotos /> and <MoreInfo />
 */
import React from 'react'
import Grid from '@material-ui/core/Grid'
import MySelect from "../Components/MySelect"
import PropTypes from 'prop-types'

const ConfigDropdown = (props) => {

   const { getSelection, options } = props

   const onChange = (e) => {
      getSelection(e.target.value)
   }
   
   return (
      <Grid data-testid='config-dropdown'>
         <MySelect name="configSelection" label="Select" options={options} onChange={onChange} />
      </Grid>
   )
}

ConfigDropdown.propTypes = {
   getSelection: PropTypes.func,
   options: PropTypes.array
}

export default ConfigDropdown
